<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-navyDark shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      بلاگ
                    </h3>
                    <p>
                      مطالعه پست‌های آموزشی برنامه‌نویسی و کسب و کار شرکت خدمات
                      تجارت سرمد، فرصت مناسبی برای یادگیری مهارت‌های نوین و
                      ارتقاء دانش حرفه‌ای شما است. با دنبال کردن این مطالب،
                      می‌توانید گامی موثر در توسعه توانمندی‌های خود در دنیای
                      دیجیتال بردارید.
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/home/Blog post-cuate.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
    </div>

    <div v-if="isLoading" class="loading-spinner">
      <div class="circle"></div>
    </div>

    <section class="section-skew" v-else>
      <div class="container-section">
        <div v-if="posts.length === 0" class="no-posts-message">
          <span>
            پستی برای نمایش وجود ندارد
          </span>
        </div>
        <div v-else class="row row-grid align-items-center">
          <div
            v-for="(post, index) in posts"
            :key="index"
            class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12"
            @click="goToPost(post)"
            style="cursor: pointer;"
          >
            <div class="card-post mb-4">
              <div class="card-img-top">
                <img :src="post.image" alt="Sample Image" />
              </div>

              <div class="card-body">
                <h5 class="card-title">{{ post.title }}</h5>
                <p class="card-text">{{ post.text }}</p>
                <p class="card-date">{{ post.date }}</p>

                <base-button
                  @click="goToPost(post)"
                  type="navyDark"
                  round
                  block
                  size="sm"
                >
                  ادامه مطلب
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "TagPosts",
  data() {
    return {
      showScrollButton: false,
      posts: [],
      currentPage: 1,
      totalPage: 1,
      isLoading: false,
    };
  },
  methods: {
    async getPosts() {
      if (this.currentPage > this.totalPage || this.isLoading) return;

      this.isLoading = true;

      try {
        const response = await axios.get(
          `${this.$baseUrl}/v1/posts/list?page=${this.currentPage}&tag=${
            this.$route.params.tagName
          }`
        );
        if (response.status === 200) {
          const newPosts = response.data.data.map((post) => ({
            id: post.id,
            image: post.coverUrl,
            title: post.title,
            text: post.subtitle,
            date: post.date,
          }));
          this.posts = [...this.posts, ...newPosts];
          this.totalPage = response.data.pager.total;
          this.currentPage++;
        }
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.isLoading = false;
      }
    },
    goToPost(post) {
      if (!post || !post.title) {
        console.error("Post or post title is undefined.");
        return;
      }

      const titleSlug = this.slugify(post.title);
      this.$router.push({
        name: "DetailsBlog",
        params: { id: post.id, title: titleSlug },
      });
    },
    slugify(text) {
      if (!text) return "untitled";

      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;

      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 100
      ) {
        this.getPosts();
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
    this.getPosts();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 30px;
  height: 30px;
  border: 5px solid #f0a500;
  border-top-color: transparent;
  border-radius: 50%;
  background-color: transparent;
  animation: spin 1s linear infinite, fill 2s ease-in-out infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fill {
  0%,
  100% {
    background-color: transparent;
  }
  50% {
    background-color: transparent;
  }
}
</style>
